import React, { useEffect, useState } from "react";
import {
  Pagination,
  SelectInput,
  TextInput,
} from "../../../components/globals";
import ContentValidation from "../../../components/common/ContentValidation";
import TableFilterBox from "../../../components/common/TableFilterBox";
import PickupTab from "./PickupTab";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { DEFAULT_PER_PAGE } from "../../../helpers/default";
import { generateParams, labelTranslates } from "../../../utils/filtering";
import {
  handleKeyDown2,
  onChangeUseState,
} from "../../../helpers/FunctionsGlobal";
import AntdConfirm from "../../../helpers/AntdConfirm";
import { useChecked } from "../../../hooks";
import { fetcherPickups } from "../../../utils/react-query";
import { Checkbox, Dropdown, Popover, Tooltip } from "antd";
import { IconDot, IconEdit } from "../../../components/Layout/Icons";
import { colors } from "../../../utils/colors";
import Axios from "axios";
import {
  antdMessageError,
  antdMessageSuccess,
  exportDocument,
} from "../../../helpers/Utils";
import { paginationCounting } from "../../../helpers/number";
import { MdOutlineCheck } from "react-icons/md";
import { tchDepartmentOptions } from "../../../helpers/GlobalOptions";

const initailLeftoversFilters = {
  supplier_name_eq: "",
  product_identifier_cont: "",
  product_title_cont: "",
};

const LeftoversTab = ({ tabId, setTabId }) => {
  const [page, setPage] = useState(1);
  const [filters, setFilters] = useState(initailLeftoversFilters);
  const [filterStr, setFilterStr] = useState("");

  const {
    isLoading,
    error,
    data: { totals = 0, data = [] } = {},
    refetch,
  } = useQuery({
    queryKey: [
      "requests/leftovers",
      { page, perPage: DEFAULT_PER_PAGE, filterStr },
    ],
    queryFn: fetcherPickups,
  });

  const mutationReceivedQuantities = useMutation({
    mutationFn: ({ ids }) => {
      return Axios.post(`/pickups/requests/update_quantities`, {
        ids,
      }).then((res) => res.data);
    },
    onSuccess: async () => {
      antdMessageSuccess("Sėkmingai išsaugota");
      refetch();
    },
    onError: (error) => {
      antdMessageError(error?.response?.data?.message);
    },
  });

  const { onChangeChecked, checkedIncluded, checkedAll, setChecked, checked } =
    useChecked([]);

  useEffect(() => {
    setChecked([]);
  }, [isLoading]);

  const handler = () => {
    if (generateParams(filters) == filterStr && page == 1) {
      return refetch();
    }
    setFilterStr(generateParams(filters));
    setPage(1);
  };

  const topPagination = paginationCounting({ page, totals });

  return (
    <>
      <div className="card">
        <div className="card-body pb-0">
          <div className="row">
            <PickupTab tabId={tabId} setTabId={setTabId} />
            <div className="col-lg-4 d-flex justify-content-center align-items-center">
              <img
                style={{ width: 40 }}
                src="/assets/product-106c1ce8c87a8ec41fc28d459e38a0b7c6abf6659290081019c1e37c3acc0b15.svg"
              />
              <span className="px-2">
                Viso likučių
                <b className="ml-1">
                  {totals == 0 && topPagination.startItem == 1
                    ? "0"
                    : `${topPagination.startItem} - ${topPagination.endItem}/${totals}`}
                </b>
              </span>
            </div>
          </div>
        </div>
        <hr className="mt-3" />
        <div
          className="sticky-top sticky-extra bg-white"
          style={{ zIndex: 15 }}
        >
          <TableFilterBox
            button1={
              <div className="float-right">
                <button
                  className="btn btn-sm mr-1 btn-danger"
                  onClick={handler}
                >
                  Filtruoti
                </button>
                <button
                  className="btn btn-sm mr-3 btn-info"
                  onClick={() => setFilters(initailLeftoversFilters)}
                >
                  Išvalyti filtravimą
                </button>
                <Dropdown
                  arrow={true}
                  trigger="click"
                  menu={{
                    items: [
                      {
                        key: "1",
                        // label: "Viską",
                        label: (
                          <div
                            onClick={() => {
                              AntdConfirm({
                                onOk: () => {
                                  exportDocument(
                                    `/pickups/requests/export_quantities?${filterStr}`,
                                    "export_quantities.xlsx",
                                    "post"
                                  );
                                  console.log("OK");
                                },
                              });
                            }}
                          >
                            Viską
                          </div>
                        ),
                      },
                      {
                        key: "2",
                        // label: "Eksportuoti",
                        label: (
                          <div
                            onClick={() => {
                              if (checked.length == 0)
                                return antdMessageError("Nepasirinkta");
                              AntdConfirm({
                                onOk: () => {
                                  exportDocument(
                                    "/pickups/requests/export_quantities",
                                    "export_quantities.xlsx",
                                    "post",
                                    {
                                      checked,
                                    }
                                  );
                                  console.log("OK");
                                },
                              });
                            }}
                          >
                            Pasirinktus
                          </div>
                        ),
                      },
                    ],
                  }}
                  placement="bottomRight"
                >
                  <button
                    className="btn btn-sm btn-dark mr-3 dropdown-toggle"
                    type="button"
                  >
                    Eksportuoti
                  </button>
                </Dropdown>
              </div>
            }
          >
            {Object.entries(filters).map(([name, value]) =>
              name == "supplier_name_eq" ? (
                <div key={name} className="px-1 col-2">
                  <SelectInput
                    label={labelTranslates[name]}
                    options={[
                      {
                        label: "Visi",
                        value: "",
                      },
                      ...tchDepartmentOptions,
                    ]}
                    value={value}
                    onChange={(value) => {
                      setFilters((prev) => ({
                        ...prev,
                        [name]: value,
                      }));
                    }}
                  />
                </div>
              ) : (
                <div key={name} className="px-1 col-2">
                  <TextInput
                    placeholder="Įvesti"
                    text={labelTranslates[name]}
                    name={name}
                    onKeyDown={handleKeyDown2(handler)}
                    value={value}
                    onChange={onChangeUseState(setFilters)}
                  />
                </div>
              )
            )}
          </TableFilterBox>
        </div>

        <ContentValidation loader={isLoading} array={data} error={error}>
          <div className="table-responsive mb-2">
            <table className="table table-striped mt-2 mb-0">
              <thead>
                <tr>
                  <th className="text-sm font-medium text-black">
                    <Checkbox
                      checked={checkedAll(data.map((s) => s.id))}
                      onChange={() =>
                        setChecked(
                          checkedAll(data.map((s) => s.id))
                            ? []
                            : data.map((s) => s.id)
                        )
                      }
                    >
                      Padalinys
                    </Checkbox>
                  </th>
                  <th className="text-sm font-medium text-black">SKU</th>
                  <th
                    className="text-sm font-medium text-black"
                    style={{
                      width: "25%",
                    }}
                  >
                    Prekė
                  </th>
                  <th
                    className="text-sm font-medium text-right pr-1"
                    style={{
                      color: "#BFBFBF",
                    }}
                  >
                    Kiekis:
                  </th>
                  <th
                    className="text-sm font-medium text-black text-center"
                    style={{
                      width: 100,
                      backgroundColor: "#0000000A",
                      borderRadius: "5px 5px 0px 0px",
                    }}
                  >
                    Kelyje
                  </th>
                  <th
                    className="text-sm font-medium text-black text-center"
                    style={{
                      width: 100,
                    }}
                  >
                    Patvirtintas
                  </th>
                  <th
                    className="text-sm font-medium text-black text-center"
                    style={{
                      width: 100,
                      backgroundColor: "#0000000A",
                      borderRadius: "5px 5px 0px 0px",
                    }}
                  >
                    Viso
                  </th>
                  <th
                    className="text-sm font-medium text-black text-center"
                    style={{
                      width: 100,
                    }}
                  >
                    Kiekis Rivilėje
                  </th>
                  <th
                    className="text-sm font-medium text-black"
                    style={{
                      width: "25%",
                    }}
                  >
                    Užsak. numeriai
                  </th>
                  <th
                    style={{
                      width: 30,
                    }}
                  ></th>
                </tr>
              </thead>
              <tbody>
                {data.map((leftover) => {
                  return (
                    <tr key={leftover.id}>
                      <td>
                        <Checkbox
                          checked={checkedIncluded(leftover.id)}
                          onChange={() => onChangeChecked(leftover.id)}
                        >
                          {leftover.supplier_code}
                        </Checkbox>
                      </td>
                      <td>{leftover.product?.identifier}</td>
                      <td>{leftover.product?.title}</td>
                      <td></td>
                      <td
                        className="text-center text-sm"
                        style={{
                          backgroundColor: "#0000000A",
                        }}
                      >
                        {leftover.pending_quantity}
                      </td>
                      <td className="text-center text-sm">
                        {leftover.orders.reduce(
                          (cur, acc) => +acc.received_quantity + cur,
                          0
                        )}
                      </td>
                      <td
                        className="text-center text-sm"
                        style={{
                          backgroundColor: "#0000000A",
                        }}
                      >
                        {leftover.available_quantity || leftover.quantity}
                      </td>
                      <td className="text-center text-sm">
                        {leftover?.rivile_quantity || 0}
                      </td>
                      <td>
                        <div
                          className="d-flex flex-wrap"
                          style={{
                            gap: 5,
                          }}
                        >
                          {leftover.orders.map((order) => (
                            <OrderBlock key={order.id} order={order} />
                          ))}
                        </div>
                      </td>
                      <td
                        style={{
                          verticalAlign: "middle",
                        }}
                      >
                        {!leftover.orders.every(
                          (order) => order.quantity <= order.received_quantity
                        ) && (
                          <Tooltip
                            placement="topRight"
                            title="Patvirtinti pilną atvykimą"
                          >
                            <button
                              style={{
                                width: 30,
                                height: 30,
                              }}
                              className="btn btn-sm btn-success"
                              onClick={() =>
                                mutationReceivedQuantities.mutate({
                                  ids: leftover.orders.map(({ id }) => id),
                                })
                              }
                            >
                              <MdOutlineCheck color="text-white text-xl" />
                            </button>
                          </Tooltip>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <Pagination
            setPagination={setPage}
            page={page}
            totals={totals}
            pageCount={DEFAULT_PER_PAGE}
          />
        </ContentValidation>
      </div>
    </>
  );
};

export default LeftoversTab;

const OrderBlock = ({ order }) => {
  const [open, setOpen] = useState(false);
  const status = !order.received_quantity
    ? "danger"
    : order.received_quantity >= order.quantity
    ? "green"
    : "warning";

  if (status == "green") {
    return (
      <div className="font-medium">
        <IconDot color={colors[status]} />
        <span className="px-1 text-decoration-underline">{order.id_order}</span>
      </div>
    );
  }

  return (
    <Tooltip placement="left" title="Pildyti dalinį atvykimą">
      <div className="font-medium">
        <IconDot color={colors[status]} />
        <span className="px-1 text-decoration-underline">{order.id_order}</span>
        {status == "warning" && (
          <span
            style={{
              color: "#BFBFBF",
            }}
          >
            ({order.received_quantity} iš {order.quantity})
          </span>
        )}
        <Popover
          placement="topLeft"
          title={
            <div className="font-semi-bold text-base py-2">
              <span
                style={{
                  color: colors["technorama"],
                }}
              >
                #
              </span>
              {order.id_order} dalinis atvykimas
            </div>
          }
          content={
            open && (
              <OrderBlockContent order={order} onClose={() => setOpen(false)} />
            )
          }
          trigger="click"
          open={open}
          onOpenChange={(newOpen) => setOpen(newOpen)}
        >
          <IconEdit className="text-sm cursor-pointer mx-1" />
        </Popover>
      </div>
    </Tooltip>
  );
};

const OrderBlockContent = ({ order, onClose }) => {
  const [receivedQuantity, setReceivedQuantity] = useState(
    order.received_quantity
  );

  const utils = useQueryClient();

  const mutationReceivedQuantity = useMutation({
    mutationFn: () => {
      return Axios.post(`/pickups/requests/update_quantity`, {
        id: order.id,
        received_quantity: receivedQuantity,
      }).then((res) => res.data);
    },
    onSuccess: async () => {
      await utils.invalidateQueries(["requests/leftovers"]);
      antdMessageSuccess("Sėkmingai išsaugota");
      onClose();
    },
    onError: (error) => {
      antdMessageError(error?.response?.data?.message);
    },
  });

  return (
    <div>
      <div
        style={{
          display: "grid",
          //   gridTemplateColumns: "repeat(2, 1fr)",
          gridTemplateColumns: "1fr 1fr",
          gridTemplateRows: "auto auto",
          gridGap: 10,
        }}
      >
        <div>
          <TextInput
            placeholder="Įvesti"
            text={"Laukiama"}
            disabled={true}
            value={order.quantity - order.received_quantity}
          />
        </div>
        <div>
          <TextInput
            placeholder="Įvesti"
            type="number"
            text={"Atvyko"}
            value={receivedQuantity}
            disabled={mutationReceivedQuantity.isLoading}
            onChange={(e) => {
              const { value } = e.target;
              if (value > order.quantity) {
                return antdMessageError(
                  "Kiekis negali būti didesnis, nei užsakytas"
                );
              }
              if (value < 0) {
                return antdMessageError("Kiekis negali būti minusinis");
              }
              setReceivedQuantity(value);
            }}
          />
        </div>
        <div></div>
        <div
          className="d-flex"
          //   style={{
          //     gridRow: "span 2",
          //   }}
        >
          <button
            className="btn btn-sm btn-white"
            disabled={mutationReceivedQuantity.isLoading}
            onClick={onClose}
          >
            Atšaukti
          </button>
          <button
            className="btn btn-sm btn-success"
            disabled={mutationReceivedQuantity.isLoading}
            onClick={() => mutationReceivedQuantity.mutate()}
          >
            Patvirtinti
          </button>
        </div>
      </div>
    </div>
  );
};
